import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

type TypeSelectionStepProps = {
  onOpenChange: (open: boolean) => void;
  setChoice: (choice: "" | "custom" | "derived") => void;
};

export const TypeSelectionStep = ({ onOpenChange, setChoice }: TypeSelectionStepProps) => {
  return (
    <div className="space-y-6 flex-1">
      <div className="text-center space-y-2">
        <h3 className="text-lg font-medium">Choose Spec List Type</h3>
        <p className="text-sm text-muted-foreground">
          Select how you want to create your spec list
        </p>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <Card
          className="cursor-pointer hover:border-blue-500 hover:shadow-md transition-all"
          onClick={() => setChoice("derived")}
        >
          <CardHeader>
            <div className="flex items-center justify-center mb-4">
              <div className="w-16 h-16 rounded-full bg-blue-100 flex items-center justify-center">
                <svg
                  className="w-8 h-8 text-blue-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  />
                </svg>
              </div>
            </div>
            <h4 className="text-lg font-semibold text-center">Derived Spec List</h4>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground text-center">
              Select specs from a master spec list and customize values
            </p>
            <div className="mt-4 flex justify-center">
              <Badge variant="secondary">Most Common</Badge>
            </div>
          </CardContent>
        </Card>

        <Card
          className="cursor-pointer hover:border-blue-500 hover:shadow-md transition-all"
          onClick={() => setChoice("custom")}
        >
          <CardHeader>
            <div className="flex items-center justify-center mb-4">
              <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center">
                <svg
                  className="w-8 h-8 text-green-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                  />
                </svg>
              </div>
            </div>
            <h4 className="text-lg font-semibold text-center">Custom Spec List</h4>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground text-center">
              Create an open spec list by uploading a CSV file
            </p>
          </CardContent>
        </Card>
      </div>

      <div className="flex justify-end gap-2 pt-4">
        <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
          Cancel
        </Button>
      </div>
    </div>
  );
};
